module.exports = __webpack_public_path__ + "img/hr-rock-big-19.a18dd67e.png";